<script>
	// NPM Modules
	import { navigate } from 'svelte-navaid';
	import Link from 'svelte-navaid/Link.svelte';
	// Stores
	import AuthUserStore from '@/Stores/AuthUserStore.js';
	// Components
	import Helmet from '@/Components/Helmet.svelte';
	import LoadingButton from '@/Components/LoadingButton.svelte';
	import TextInput from '@/Components/TextInput.svelte';
	import Logo from '@/Components/Logo.svelte';
	// Constants
	import config from '@/config';

	let errors = null;

	let sending = false;
	let values = {
		email: '',
		password: '',
		remember: true
	};

	function handleChange(e) {
		const key = e.target.name;
		const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;

		values = {
			...values,
			[key]: value
		};
	}

	function handleSubmit() {
		sending = true;
		AuthUserStore.login(values)
			.then((response) => {
				if (response.requires_two_factor) {
					return navigate('/challenge');
				}
				navigate('/');
			})
			.catch((error) => {
				errors = error;
			})
			.finally(() => (sending = false));
	}
</script>

<Helmet title="Login" />
<div class="relative">
	<div class="flex items-center justify-center min-h-screen p-2 sm:p-6 bg-brand-black">
		<div class="w-full max-w-md">
			{#if config.BRAND == 'socialbet'}
				<img
					src="/images/logo.png"
					class="block max-w-xs mx-auto h-10"
					alt={config.BRAND_NAME}
					height="32px"
					width="126px"
				/>
			{:else}
				<div class="w-auto h-20 mx-auto block px-16">
					<Logo />
				</div>
			{/if}

			<form on:submit|preventDefault={handleSubmit} class="mt-8 overflow-hidden bg-white rounded-lg shadow-xl">
				<div class="px-4 sm:px-10 py-12">
					<h1 class="text-3xl font-bold text-center">Welcome Back!</h1>
					<div class="w-24 mx-auto mt-6 border-b-2" />

					<TextInput
						className="mt-6"
						label="Email"
						name="email"
						type="email"
						errors={errors && errors.email}
						bind:value={values.email}
						onChange={handleChange}
					/>

					<TextInput
						className="mt-6"
						label="Password"
						name="password"
						type="password"
						errors={errors && errors.password}
						bind:value={values.password}
						onChange={handleChange}
					/>
				</div>
				{#if errors && errors.error}
					<div class="-mt-3 mb-3 text-center form-error">{errors.error[0]}</div>
				{/if}
				<div class="flex items-center justify-between px-10 py-4 bg-gray-100 border-t border-gray-200">
					<Link class="hover:underline" tabindex="-1" href="/forgot">Forget password?</Link>

					<LoadingButton
						type="submit"
						loading={sending}
						className="px-6 py-3 rounded bg-secondary text-white text-sm font-bold
          whitespace-nowrap hover:bg-dark"
					>
						Login
					</LoadingButton>
				</div>
			</form>
		</div>
	</div>
	<div class="absolute bottom-0 left-0 text-xs text-light-grey m-2">
		v{config.APP_VERSION}
	</div>
</div>
